// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iEiBG","btnGradPrimary":"Button_btnGradPrimary__XmRZC","btnGradSecondary":"Button_btnGradSecondary__ZOF1W"};